module.exports = __webpack_public_path__ + "img/floor_3.d8acf615.png";